import React from 'react';

const STYLES = {
  reserved:           'bg-amber-50 text-amber-700 border-amber-200',
  pending_payment:    'bg-orange-50 text-orange-700 border-orange-200',
  paid:               'bg-ocean-50 text-ocean-700 border-ocean-200',
  unlocked:           'bg-emerald-50 text-emerald-700 border-emerald-200',
  cancelled:          'bg-red-50 text-red-600 border-red-200',
  checked_in:         'bg-reef-50 text-reef-700 border-reef-200',
  open:               'bg-orange-50 text-orange-700 border-orange-200',
  confirmed:          'bg-emerald-50 text-emerald-700 border-emerald-200',
  rejected:           'bg-red-50 text-red-600 border-red-200',
  draft:              'bg-slate-100 text-slate-500 border-slate-200',
  published:          'bg-ocean-50 text-ocean-600 border-ocean-200',
  ticket_sale_active: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  sold_out:           'bg-red-50 text-red-600 border-red-200',
  finished:           'bg-slate-100 text-slate-500 border-slate-200',
  archived:           'bg-slate-100 text-slate-400 border-slate-200',
  free:               'bg-emerald-50 text-emerald-700 border-emerald-200',
  booked:             'bg-ocean-50 text-ocean-700 border-ocean-200',
  blocked:            'bg-red-50 text-red-600 border-red-200',
  user:               'bg-slate-100 text-slate-600 border-slate-200',
  participant:        'bg-reef-50 text-reef-700 border-reef-200',
  admin:              'bg-amber-50 text-amber-700 border-amber-200',
  superadmin:         'bg-ocean-50 text-ocean-700 border-ocean-200',
};

const LABELS = {
  reserved: 'Reserviert', pending_payment: 'Ausstehend', paid: 'Bezahlt',
  unlocked: 'Freigeschaltet', cancelled: 'Storniert', checked_in: 'Eingecheckt',
  open: 'Offen', confirmed: 'Bestätigt', rejected: 'Abgelehnt',
  draft: 'Entwurf', published: 'Veröffentlicht', ticket_sale_active: 'Verkauf aktiv',
  sold_out: 'Ausverkauft', finished: 'Beendet', archived: 'Archiviert',
  free: 'Frei', booked: 'Gebucht', blocked: 'Gesperrt',
  user: 'User', participant: 'Teilnehmer', admin: 'Admin', superadmin: 'Superadmin',
};

export default function Badge({ status, custom }) {
  const style = STYLES[status] || 'bg-slate-100 text-slate-500 border-slate-200';
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-semibold border ${style} whitespace-nowrap tracking-wide`}>
      {custom || LABELS[status] || status}
    </span>
  );
}
